/** Top folder of the firm's files in the library. */
export const CLIENTS_FOLDER: string = 'Clients';
